import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import styled from 'styled-components'
import { BtnPrimary } from '../../StyledComponents'

// material imports
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress';

// functions and properties
const CTextField = styled(TextField)`
  margin: 5px !important;
  flex: 1;
  
  input {
    border-radius: 4px;
    background-color: white;
    color: ${({theme}) => theme.GRAY};
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  color: red;
  margin-left: 5px;
`;

const getEmailError = (err) => {
  switch(err.type) {
    case 'required':
      return 'Required';
    case 'pattern':
      return 'Please enter a valid email so we can send you your TEA qualification report';
    default:
      break;
  }
}

const Form = ({onSubmit}) => {

  const { register, handleSubmit, errors, reset } = useForm();
  const [loading, setLoading] = useState(false);

  function submit(data) {
    setLoading(true);
    onSubmit(data, reset, () => setLoading(false));
  }

  return (
    <form onSubmit={handleSubmit(submit)}>
      <Grid
        container
        direction="column"
        style={{marginTop: 12}}
        align="left"
      >
        <Grid container wrap="nowrap">
          <Grid container direction="column">
            <CTextField
              variant="outlined"
              size="small"
              placeholder="First name"
              inputRef={register({required: true})}
              name="firstName"
            />
            {
              errors.firstName && <ErrorMessage>Required</ErrorMessage>
            }
          </Grid>
          <Grid container direction="column">
            <CTextField
              variant="outlined"
              size="small"
              placeholder="Last name"
              inputRef={register({required: true})}
              name="lastName"
            />
            {
              errors.lastName && <ErrorMessage>Required</ErrorMessage>
            }
          </Grid>
        </Grid>
        <CTextField
          variant="outlined"
          size="small"
          placeholder="Enter your email address here to start the EB-5 process"
          inputRef={register({required: true, pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/})}
          name="email"
        />
        {
          errors.email && <ErrorMessage>{getEmailError(errors.email)}</ErrorMessage>
        }
        <BtnPrimary
          onClick={ () => handleSubmit(submit) }
          variant="contained"
          color="primary"
          disableElevation
          size="small"
          style={{margin: 5}}
        >
          <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {
              loading ?
                <CircularProgress color="white" size={26} /> :
                'Submit and Get Started with EB-5 Today'
            }
          </div>
        </BtnPrimary>
      </Grid>
    </form>
  );
}

export default Form;
